module.exports = __webpack_public_path__ + "img/901321181.21dbcb48.png";